/**
 * Componente para input de observações com contador
 */

import React from 'react';
import { FileText } from 'lucide-react';

interface ObservacoesInputProps {
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
}

export const ObservacoesInput: React.FC<ObservacoesInputProps> = ({
  value,
  onChange,
  maxLength = 500
}) => {
  const remaining = maxLength - value.length;
  const isNearLimit = remaining <= 50;

  return (
    <div className="space-y-2">
      <label className="block text-xs text-gray-300 font-medium flex items-center gap-1.5">
        <FileText className="w-3.5 h-3.5" />
        Observações
        <span className="text-gray-500 text-[10px] font-normal">(opcional)</span>
      </label>
      
      <div className="relative">
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Adicione observações sobre este arquivo..."
          rows={3}
          maxLength={maxLength}
          className="w-full px-2 py-2 bg-navy-800 border border-navy-600 rounded-lg text-white placeholder-gray-400 text-sm focus:outline-none focus:ring-1 focus:ring-blue-400/50 focus:border-transparent resize-none"
        />
        
        {/* Contador de caracteres */}
        <div
          className={`absolute bottom-2 right-2 text-[10px] font-medium ${
            isNearLimit ? 'text-yellow-400' : 'text-gray-500'
          }`}
        >
          {remaining} / {maxLength}
        </div>
      </div>

      {isNearLimit && (
        <p className="text-[10px] text-yellow-400">
          Atenção: você está próximo do limite de caracteres.
        </p>
      )}
    </div>
  );
};

